import { connect } from 'react-redux';
import { getOriginalUser, getCurrentUser } from '../../reducers/selectors';
import { logout } from '../../actions';
import { ROUTE_DOWNLOAD_CLI } from '../../constants/pathnames';
import TokenView from './TokenView';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state, ownProps) => {
  const user = ownProps.showImpersonatedUser ? getCurrentUser(state) : getOriginalUser(state);
  const showCLIDownload =
    ownProps.match.isExact === true && ownProps.match.url === ROUTE_DOWNLOAD_CLI ? true : false;
  return {
    user,
    showCLIDownload,
  };
};

export default withRouter(connect(mapStateToProps, { logout })(TokenView));
